/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from 'react';
import styles from './TabChat.module.scss';
import { BaechaList2TableItem } from "../../../BaechaList2.interface";
import { getChatMessageByBaechaIdAPI } from "../../../../../api/baechaAPI";
import { Space, Typography, Image } from 'antd';
import dayjs from 'dayjs';

const CHAT_MESSAGE_BOT_UUID = '6185b6c7-23d5-424e-8782-312426dba2f6';

interface TabChatProps {
	baechaId?: string;
	baljuMemberId?: string;
	sujuMemberId?: string;
}

const TabChat = ({ baechaId, baljuMemberId, sujuMemberId }: TabChatProps) => {
	const [chatMsgList, setChatMsgList] = useState<any[]>([]);

	useEffect(() => {
		if (baechaId) {
			getChatMessageByBaechaIdAPI(baechaId)
				.then((res) => setChatMsgList(res))
				.catch((e) => console.error(e));
		}
	}, [baechaId]);

	const formatTime = (date: string) => dayjs(date).format('MM-DD HH:mm');

	const getMessageType = (msg: any): 'bot' | 'left' | 'right' => {
		if (msg.memberId === CHAT_MESSAGE_BOT_UUID) return 'bot';
		if (msg.memberId === baljuMemberId) return 'left';
		if (msg.memberId === sujuMemberId) return 'right';
		return 'left';
	};

	const renderMessage = (msg: any) => {
		const type = getMessageType(msg);
		const isImage = msg.msgType === 'image';
		const isRight = type === 'right';

		if (type === 'bot') {
			return (
				<div key={msg.id} style={{ textAlign: 'center', margin: '8px 0' }}>
					<Typography.Text type="secondary" style={{ fontSize: 12 }}>
						{msg.text}
					</Typography.Text>
				</div>
			);
		}

		return (
			<div
				key={`${msg.id}-${msg.fileId ?? 'text'}`}
				style={{
					display: 'flex',
					justifyContent: isRight ? 'flex-end' : 'flex-start',
				}}
			>
				<Space
					direction="vertical"
					align={isRight ? 'end' : 'start'}
					size={2}
				>
					{/* bubble */}
					<div
						style={{
							background: isRight ? '#ffe066' : '#f5f5f5',
							padding: '8px 12px',
							borderRadius: 12,
							maxWidth: 200,
							wordBreak: 'break-word',
						}}
					>
						{isImage ? (
							<Image
								src={msg.imageInfo?.url}
								width={200}
								style={{
									maxWidth: '100%',
									borderRadius: 8,
								}}
							/>
						) : (
							<span style={{ whiteSpace: 'pre-line' }}>
                {msg.text}
              </span>
						)}
					</div>

					{/* 날짜 */}
					{msg.exifGeoInfo && (
						<Typography.Text style={{ fontSize: 13 }}>
							{msg.exifGeoInfo}
						</Typography.Text>
					)}


					{/* 시간 */}
					<Typography.Text type="secondary" style={{ fontSize: 11 }}>
						{formatTime(msg.createDate)}
					</Typography.Text>
				</Space>
			</div>
		);
	};

	return (
		<div className={styles.wrap}>
			<div className={styles.chatContainer}>
				<Space direction="vertical" style={{ width: '100%' }} size={8}>
					{chatMsgList.map(renderMessage)}
				</Space>
			</div>
		</div>
	);
};

export default TabChat;
